export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> 목록과 체크박스`,
    datas: [
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 순서가 없는 목록`
        },
        { type: "text",
            content: "목록은 -, +, * 기호를 사용하여 사용하여 적용할 수 있습니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section04/exam01.md",
            content:
`- 1
- 2
- 3
---
+ one
+ two
+ three
---
* 하나
* 두울
* 세엣`
        },
        { type: "text",
            content: "세 기호에 따른 목록의 모양 차이는 없습니다. 취향에 맞는 것을 골라 사용하면 됩니다."
        },



        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 순서가 있는 목록`
        },
        { type: "text",
            content: "순서가 있는 목록은 숫자와 .(점)기호를 사용합니다. 여기서 숫자의 증감 폭은 표시되는 숫자와 연관이 없습니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section04/exam02.md",
            content:
`1. 하나
2. 두울
3. 세엣
---
2. 두울
4. 네엣
8. 여덟
---
3. 세엣
2. 두울?
1. 하나!?
---
1. 하나
1. 하나?
1. 하나!?`
        },
        { type: "text",
            content: "위 코드를 수행해보면 어느 정도 숫자의 규칙을 알아내실 수 있습니다."
        },



        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 중첩 목록`
        },
        { type: "text",
            content: "순서가 있는 목록은 숫자와 .(점)기호를 사용합니다. 여기서 숫자의 증감 폭은 표시되는 숫자와 연관이 없습니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section04/exam03.md",
            content:
`- 1
    - 1>1
    - 1>2
    - 1>3
- 2
    + 2>1
    * 2>2
    - 2>3
- 3
  * 3>1
    + 3>1>1
    + 3>1>2
  * 3>2
    + 3>2>1
      - 3>2>1>1
      - 3>2>1>2
    + 3>2>2
      - 3>2>2>1
        * 3>2>2>1>1
          + 3>2>2>1>1>1
            - 3>2>2>1>1>1>1`
        },


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 체크 박스 리스트`
        },
        { type: "text",
            content: "Github에서는 체크박스 리스트 기능을 추가로 사용할 수 있습니다."
        },
        { type: "code2", code: "md", drag: true,
            content:
`- [x] 체크된 박스
- [ ] 체크되지 않은 박스`
        },
        { type: "text",
            content: "할일 목록이나 업데이트 예정과 진행된 항목 등을 표시하기 좋습니다."
        },
        { type: "code", code: "plaintext", 
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section04/exam04.md",
            content:
`### 오늘에 할일

- [ ] ~~일찍 일어나기~~
- [x] 숨쉬기
- [x] 밥먹기
- [ ] 잠자기`
        },

        
        { type: "subtitle",
            content: `<i class="fa fa-check-square"></i> Check it!`
        },
        { type: "oxquiz",
            content: "마크다운 문법으로 목록을 만들때는 *(별표), -(대시), _(언더바) 기호를 사용한다.",
            ans: false,
        },
        { type: "oxquiz",
            content: "Github의 마크다운으로 순서가 있는 목록을 만들떄는 항상 오름차순으로 번호가 생성된다.",
            ans: true,
        },
        { type: "quiz",
            content: "[Quiz] 다음 중 체크된 목록의 박스를 만드는 문법으로 올바른 것은?",
            questions: [
                "- [o]",
                "- [x]",
                "- [v]", 
                "- [*]", 
            ],
            answers: [1],
        },



        { type: "next",
            content: "다음",
            url: "/sections/05"
        },
    ]
}